<template>
  <div class="d-flex justify-content-center align-items-center h-100 w=100">
    <i :id="getIdDisabled" class="fas fa-ban pointer text-danger" v-if="status === 0" @click="onChangeStatus"></i>
    <b-tooltip v-if="status === 0" :disabled="disabled" placement="left" :target="getIdDisabled" triggers="hover">{{ $lang.Common.Tooltip.ButtonActive }}</b-tooltip>
    <i :id="getIdEnabled" class="fas fa-check pointer text-third" v-if="status === 1" @click="onChangeStatus"></i>
    <b-tooltip v-if="status === 1" :disabled="disabled" placement="left" :target="getIdEnabled" triggers="hover">{{ $lang.Common.Tooltip.ButtonInactive }}</b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'ActionCellRenderer',
  data () {
    return {
      status: null,
      disabled: false
    }
  },
  mounted () {
    this.status = this.params.data.status
    this.disabled = this.params.disabled === true
  },
  computed: {
    getIdEnabled () {
      return 'status-enabled' + this.params.data.codigo
    },
    getIdDisabled () {
      return 'status-disabled' + this.params.data.codigo
    }
  },
  methods: {
    onChangeStatus () {
      this.$bvModal.msgBoxConfirm(this.$lang.Common.LabelConfirmation, {
        title: 'Confirma alteração do Status?',
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
        .then(confirmed => {
          if (confirmed) {
            this.params.onChangeStatus(this.params)
            // this.params.node.setDataValue('status', this.params.data.status === 1 ? 0 : 1)
          }
        })
    }
  }
}
</script>

<style scoped>
i {
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/copitem/actionCellRenderer.vue